export default __webpack_public_path__ + "static/media/11A.020.4a4267e6.png";